import apiHandler from './../../utilities/apiHandler.js'

const CreditLineApiHandler = {

	getCreditLineConfig: function () {
		var URL = "api/credit/gateway/config";
		return apiHandler.get(URL);
	},

	getCreditLines: function (request) {
		var URL = "api/credit/gateway/fetch/credit-line";
		return apiHandler.post(URL, request);
	},

	mergeCreditLines: function (request) {
		var URL = "api/credit/gateway/credit-line/merge/";
		return apiHandler.post(URL, request);
	},

	updateStatusOrNachAccountId: function(request) {
		var URL = "api/credit/gateway/credit_line/update/";
		return apiHandler.post(URL, request);
	},

	getCustomerDetails: function (bzid){
		var URL = "api/credit/gateway/customer-details/"+bzid;
		return apiHandler.get(URL);
	},

	submitCreditLineDetails: function (obj){
		var URL = "api/credit/gateway/create/creditLine";
		return apiHandler.post(URL,obj);
	}
}

export default CreditLineApiHandler;


// WEBPACK FOOTER //
// ./src/screens/creditLines/CreditLineApiHandler.js